import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Container,
    TwoColumnsLayout,
    ImageColumn,
    ContentColumn,
    ModuleImage,
    Text,
    ContentFooter,
    ButtonContainer,
} from './CultureFitOptOutIntro.style';
import culturalFitImage from 'assets/images/cultural_fit_module.png';
import ShadowButton from 'components/shared/ShadowButton/ShadowButton';
import withMediaQuery from '../../../hoc/MediaQuery/withMediaQuery';
import { Spacer } from '../../shared/CameraSetupView/MobileView/MobileCameraSetup/MobileCameraSetup.style';

const CultureFitOptOutIntro = (props) => {
    const { t } = useTranslation();
    const { onNext, isTabletAndMobileSize } = props;

    return (
        <Container>
            {isTabletAndMobileSize && (
                <>
                    <TwoColumnsLayout>
                        <Text>
                            <h1>{t('CULTURE_FIT_OPT_OUT_INTRO.TITLE')}</h1>
                        </Text>
                        <ImageColumn>
                            <ModuleImage src={culturalFitImage} />
                        </ImageColumn>
                    </TwoColumnsLayout>
                    <ContentColumn>
                        <div>
                            <Text>
                                <p>
                                    {t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_1')}
                                </p>
                            </Text>
                            <Text>
                                <p>
                                    {t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_2')}
                                </p>
                            </Text>
                            <Text>
                                <p>
                                    {t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_3')}
                                </p>
                            </Text>
                            <Text>
                                <p>
                                    {t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_4')}
                                </p>
                            </Text>
                        </div>
                        <Spacer />
                        <ContentFooter>
                            <ButtonContainer>
                                <ShadowButton
                                    size={'small'}
                                    onClick={() => onNext()}>
                                    {t(
                                        'CULTURE_FIT_INTRODUCTION.START_TASK_BUTTON',
                                    )}
                                </ShadowButton>
                            </ButtonContainer>
                        </ContentFooter>
                    </ContentColumn>
                </>
            )}
            {!isTabletAndMobileSize && (
                <TwoColumnsLayout>
                    <ImageColumn>
                        <ModuleImage src={culturalFitImage} />
                    </ImageColumn>
                    <ContentColumn>
                        <Text>
                            <h1>{t('CULTURE_FIT_OPT_OUT_INTRO.TITLE')}</h1>
                            <p>{t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_1')}</p>
                            <p>{t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_2')}</p>
                            <p>{t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_3')}</p>
                            <p>{t('CULTURE_FIT_OPT_OUT_INTRO.MESSAGE_4')}</p>
                        </Text>
                        <ContentFooter>
                            <ButtonContainer>
                                <ShadowButton onClick={() => onNext()}>
                                    {t(
                                        'CULTURE_FIT_INTRODUCTION.START_TASK_BUTTON',
                                    )}
                                </ShadowButton>
                            </ButtonContainer>
                        </ContentFooter>
                    </ContentColumn>
                </TwoColumnsLayout>
            )}
        </Container>
    );
};

export default withMediaQuery(CultureFitOptOutIntro);
